
import { LocationGroupModel, LocationGroupTypeEnum } from '@/libs/Api';
import { Guid } from '@/libs/common/functions/guid';
import Page from '@/Page.vue';
import { Component, Prop, VModel } from 'vue-property-decorator';

@Component({})
export default class LocationGroupList extends Page {
    @Prop() locationGroupType!: LocationGroupTypeEnum;
    @Prop() locationId!: string;

    @VModel() locationGroups!: LocationGroupModel[];

    get filteredLocationGroups() {
        return this.locationGroups.filter((x) => x.locationGroupType == this.locationGroupType);
    }

    private addClick() {
        const items = [...this.locationGroups];
        items.push({
            id: Guid.EmptyGuid(),
            locationId: this.locationId,
            groupId: undefined,
            group: undefined,
            locationGroupType: this.locationGroupType,
        } as LocationGroupModel);
        this.$emit('input', items);
    }

    private deleteItem(id: string) {
        const item = this.locationGroups.find((x) => x.id == id);
        if (item) {
            const items = [...this.locationGroups];
            items.splice(items.indexOf(item), 1);
            this.$emit('input', items);
        }
    }

    getExceptGroups(excludeId: string) {
        return this.locationGroups
            .filter((x) => x.locationGroupType == this.locationGroupType && x.groupId != excludeId)
            .map((x) => x.groupId!);
    }
}
